import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Package, ArrowRight } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-obsidian text-stark flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-10">
          <span className="bg-signal text-white p-1.5"><Package weight="bold" size={22} /></span>
          <span className="font-display font-semibold text-2xl tracking-tight">MAMA PARCEL</span>
        </Link>
        <div className="border-2 border-neutral-800 bg-neutral-900 p-8">
          <p className="font-mono text-xs tracking-[0.3em] uppercase text-signal mb-2">Admin Portal</p>
          <h1 className="font-display font-semibold text-3xl tracking-tight mb-8">Sign in</h1>
          <form onSubmit={submit} className="space-y-6" data-testid="login-form">
            <div>
              <label className="font-mono text-[11px] tracking-widest uppercase text-neutral-400">Email</label>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-transparent border-b-2 border-neutral-700 focus:border-signal outline-none py-2 text-stark transition-colors" />
            </div>
            <div>
              <label className="font-mono text-[11px] tracking-widest uppercase text-neutral-400">Password</label>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-transparent border-b-2 border-neutral-700 focus:border-signal outline-none py-2 text-stark transition-colors" />
            </div>
            {error && <p className="text-red-400 text-sm font-sans" data-testid="login-error">{error}</p>}
            <button data-testid="login-submit" disabled={loading}
              className="group w-full flex items-center justify-center gap-2 bg-signal text-white font-medium px-6 py-3 hover:bg-signal-hover transition-colors disabled:opacity-60">
              {loading ? "Signing in..." : "Sign in"} <ArrowRight weight="bold" className="group-hover:translate-x-1 transition-transform" />
            </button>
          </form>
        </div>
        <Link to="/" className="block text-center mt-6 font-mono text-xs tracking-widest uppercase text-neutral-500 hover:text-signal transition-colors">
          ← Back to site
        </Link>
      </div>
    </div>
  );
}
